import { render, staticRenderFns } from "./machineAdmin.vue?vue&type=template&id=587667a3&scoped=true&"
import script from "./machineAdmin.vue?vue&type=script&lang=js&"
export * from "./machineAdmin.vue?vue&type=script&lang=js&"
import style0 from "./machineAdmin.vue?vue&type=style&index=0&id=587667a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587667a3",
  null
  
)

export default component.exports